import { init, metrics } from '@sentry/browser';

// IMPORTANT: We can use sentry here because the embedded wallet does NOT handle any key material.
if (__USE_SENTRY__) {
  init({
    dsn: 'https://45566d04c9b0b02b78a8b08e61053f4c@o4507181508919296.ingest.us.sentry.io/4507181511999488',
  });
}

export function trackMissingIcon(name: string, type: 'token' | 'chain') {
  metrics.increment('missing_icon', 1, {
    tags: {
      name,
      type,
    },
  });
}
